import React from "react";
import { bindWeldProcess, getColumnClasses } from "./pqrDataUtils";
import { pqrStyles } from "./pqrStyles";

const PQRPositionTable = ({ pdf }) => {
  const { colwidth, col1Class, col2Class, col3Class } = getColumnClasses(pdf,"position");
  
  return (
    <>
      <div style={pqrStyles.group}>
        <div className="PQRbasemetal">POSITION(QW-405)</div>
      </div>
      <div style={pqrStyles.container}>
        <table id="table" className="PQRTable2" cellSpacing="0" style={{width:"570px"}}>
          <tbody>
            <tr className="PQRtrhide PQR_Toprt">
              <th className="PQRfillerMetalth PQR_noBotm" style={{ width: "27%" }}>
                Position of groove
              </th>
              <td className={col1Class} style={{ width: colwidth}}>
                {bindWeldProcess(pdf, "PQRD_Position_PositionofGroove", 1)}
              </td>
              <td className={col2Class} style={{ width: colwidth}}>
                {bindWeldProcess(pdf, "PQRD_Position_PositionofGroove", 2)}
              </td>
              <td className={col3Class} style={{ width: colwidth}}>
                {bindWeldProcess(pdf, "PQRD_Position_PositionofGroove", 3)}
              </td>
            </tr>
            <tr className="PQRtrhide PQR_Botmrt">
              <th className="PQRfillerMetalth PQR_noTop" style={{ width: "27%" }}>Weld progression</th>
              <td className={col1Class} style={{ width: colwidth }}>
                {bindWeldProcess(pdf, "PQRD_Position_WeldProgression", 1)}
              </td>
              <td className={col2Class} style={{ width: colwidth}}>
                {bindWeldProcess(pdf, "PQRD_Position_WeldProgression", 2)}
              </td>
              <td className={col3Class} style={{ width: colwidth}}>
                {bindWeldProcess(pdf, "PQRD_Position_WeldProgression", 3)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PQRPositionTable;